module.exports = __webpack_public_path__ + "static_web/img/wb_juan_zeng_header.8555ddb2.jpg";